const industryType = {
  Minimum: 'Minimum',
  Total: 'Total'
};

export default industryType;


// WEBPACK FOOTER //
// ./src/constants/industryType.js